import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import imageGallery from './modules/ImageGallery';
import payments from './modules/Payments';
import payouts from './modules/Payouts';
import payPal from './modules/PayPal';
import product from './modules/Product';
import localisation from './modules/Localisation';

Vue.use(Vuex);

const store = new Vuex.Store({
    plugins: [
        createPersistedState({
            paths: [
                'product',
                'imageGallery'
            ]
        }),
        createPersistedState({
            paths: [
                'payments',
                'payouts',
                'payPal',
                'localisation'
            ],
            storage: window.sessionStorage
        })
    ],
    modules: {
        product,
        imageGallery,
        payments,
        payouts,
        payPal,
        localisation
    }
});

export default store;
